<template>
    <div class="page-content">

        <Row type="flex" justify="center">
            <!--        侧边栏 start -->
            <i-col :lg="4">
                <SideBar class="mobile-no-sidebar" />
            </i-col>
            <!--        侧边栏 end -->

            <i-col :xs="24" :md="24" :lg="12">
                <div class="right-content">
                    <img class="activity-image" :src="activityData.img" alt="activity-image">
                    <div class="text-content">
                        <div class="activity-title">
                            {{activityData.name}}
                        </div>
                        <div class="activity-text">
                            {{activityData.text}}
                        </div>
                        <div class="start-end-date">
                            <Icon type="md-arrow-dropright-circle" size="18" color="#00C957"/>
                            <div class="date-title">{{$t('message.activity.activityStartDate')}}：</div>
                            <div class="date-value">{{getDateStr(activityData.start_time)}}</div>
                        </div>
                        <div class="start-end-date">
                            <Icon type="md-radio-button-on" size="18" color="red" />
                            <div class="date-title">{{$t('message.activity.activityEndDate')}}：</div>
                            <div class="date-value">{{getDateStr(activityData.end_time)}}</div>
                        </div>
                    </div>
                </div>
            </i-col>
        </Row>

    </div>
</template>

<script>
  import {urlRequest} from "../../common/common";
  import SideBar from "../SideBar/SideBar";
  import moment from 'moment';

  export default {
    name: "ActivityDetail",
    components: {SideBar},
    data() {
      return {
        // 活动Id
        activityId: '',
        // 活动数据
        activityData: {},
      }
    },

    created() {

      console.log('从前页传来的参数：', this.$route.params);
      let {activityId} = this.$route.params;
      this.activityId = activityId;

      // 加载数据
      this.loadData();

    },

    methods: {
      // 加载数据
      loadData() {
        urlRequest({
          url: this.api.getActivityList,
          method: 'POST',
          data: {
            'id': this.activityId
          }
        }).then(res => {
          this.activityData = res.data.msg[0];
        });
      },

      // 格式化日期
      getDateStr(datetime) {
        return moment(datetime).format('YYYY-MM-DD');
      }
    },

  }
</script>

<style lang="scss" scoped>
    @import "@/assets/style/mainStyle.scss";
    @import "ActivityDetail.scss";

</style>
